<template>
  <div>
    <NavigationBar
      titel="Archiv"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "availability-archive",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `archive/leaves`,
      tabs: [
        { id: 1, name: "Abwesenheiten", route: `leaves` },
        // { id: 2, name: "Abfragen", route: `requests` },
      ],
    };
  },
};
</script>
